import React, { useEffect, useState } from 'react';
import useParam from '../../context/ParamContext';
import { Typography } from '@mui/material';
import { formatValue } from '../../utils/resource.planner';

const TooltipContent = ({ eventInfo }) => {
  const { params } = useParam();
  const [tooltipObj, setTooltipObj] = useState(null);

  useEffect(() => {
    let paramKey = 'PROJECT_EMPLOYEE_PLANNER_HINT_CONTENT';

    if (params[paramKey]) {
      const parsedObj = JSON.parse(params[paramKey]);
      setTooltipObj(parsedObj);
    }
  }, [params]);

  const task = eventInfo.event._def.extendedProps.eventData;

  const getFieldValue = (obj, path) => {
    return path.split('.').reduce((acc, part) => {
      if (Array.isArray(acc)) {
        return acc.map((item) => item[part]);
      }
      return acc ? acc[part] : null;
    }, obj);
  };

  const setTooltipContent = () => {
    if (!tooltipObj || !task) {
      return null;
    }

    return tooltipObj.map((item, index) => {
      const { label, fieldName, type } = item;
      const taskValue = getFieldValue(task, fieldName);

      return (
        <Typography key={index}>
          {label}: {formatValue(taskValue, type)}
        </Typography>
      );
    });
  };

  const tooltipContent = setTooltipContent();

  return <div>{tooltipContent}</div>;
};

export default TooltipContent;
